import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { sortSubscriptions } from '@Helpers/utilities-ryan';
import { isArray } from 'lodash-es';

export default class GetSubscriptionsList extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'subscriptions-getSubscriptionsList',
    });
  }

  onSuccess(data) {

    if( data && isArray(data) ) {

      for(let i = 0; i < data.length; i++) {
        data[i].filterString = `${data[i].type}, ${data[i].name ? data[i].name : ''}, ${data[i].id ? data[i].id : ''}`.toLowerCase();
      }

      data.sort(sortSubscriptions)
    }

    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        admin: {
          subscriptions: {
            list: data
          },
        },
      },
    });
    super.onSuccess(...arguments);
  }
}
